/**
 * NOTIF-003 — "seen" (decision 2, amended 2026-10-21): a Heads-up / Info row counts as read once
 * the user has actually looked at it. With a pointer that means the cursor rested on the row for
 * a moment (or the row has keyboard focus); on a touch device, where nothing hovers, it means
 * the row is in view — rows that need a scroll are read after the scroll. Action needed is
 * never "seen", only clicked.
 */

/** How long the cursor (or focus) rests on a row before it counts as seen (owner: 0.15 s). */
export const SEEN_DWELL_MS = 150

/** Share of a row that must be in the viewport before a touch device counts it as seen. */
export const SEEN_VISIBLE_THRESHOLD = 0.6

let dwellOverride: number | null = null

export function seenDwellMs(): number {
  return dwellOverride ?? SEEN_DWELL_MS
}

/** Test seam: shorten the dwell (null restores the default). */
export function setSeenDwellForTests(ms: number | null): void {
  dwellOverride = ms
}

/** True when the device has something that hovers; environments without matchMedia count as such. */
export function hoverCapable(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true
  try {
    return window.matchMedia('(hover: hover)').matches
  } catch {
    return true
  }
}
